import React from 'react'
import PropTypes from 'prop-types'
// eslint-disable-next-line import/no-named-as-default
import Helmet from 'react-helmet'
import { applicationStateShape } from '../../utils/shapes'
import replaceApplicationStatePlaceholders from '../../utils/replaceApplicationStatePlaceholders'

const ScriptLoader = ({ url, applicationState, ...props }) => (
  <Helmet>
    <script src={replaceApplicationStatePlaceholders(url, applicationState)} {...props} />
  </Helmet>
)

ScriptLoader.defaultProps = {
  type: 'text/javascript',
}

ScriptLoader.propTypes = {
  /**
   * The url of the script to load
   */
  url: PropTypes.string.isRequired,
  /**
   * An object of application data that can be used in the url
   */
  applicationState: applicationStateShape,
  /**
   * The script type
   */
  type: PropTypes.string.isRequired,
}

export default ScriptLoader
